import Tile from '@/store/models/Tile'
import { SelectionType } from '@/data/enums'

export default class TilePayload {
  public item!: Tile
  public type!: SelectionType

  constructor (item: Tile, type: SelectionType) {
    this.item = item
    this.type = type
  }
}
